/* Group-membership tabs constants */

export const GENAI_REVIEWERS = "genai-reviewers";
export const QUALITY_REVIEWERS_TAB = "quality-reviewers";
export const REVIEWERS = "reviewers";
export const INVITED = "invited";
export const MEMBERS = "members";

/* User type */
export const USER_TYPE_GENAI = "genai";

/* User role */
export const USER_ROLE_GENAIEXPERT = "GenAIExpert";
export const USER_ROLE_AIEXPERT = "ai-expert";

/* GenAI membership configurations */
export const EQUAL_SPLIT = "equalSplit";
export const CUST_RATING = "custRating";
export const CONTEXT = "context";
export const VOLUME = "volume";
export const AI_CONFIG_PASSIVE = "aiConfigPassive";

/* IOT tasklist minimum threshold */
export const TASKLIST_MINIMUM_THRESHOLD = 20;

/* ContactUs-TaskList-Brands-Conversation Hisotry for Secure Access */
export const LIMITLESS = "Limitless";

/* Onbarding Tab types  */

export const PQS = "PQs";
export const OUTCOME = "Outcome";
